import React, { useState } from 'react'
import { ColumnDefinition } from 'common/components/DataTable'
import BigSpinner from 'common/components/BigSpinner'
import { DataTable } from 'common/components/DataTable'
import { usePaginatedFetch } from 'common/hooks/usePaginatedFetch'
import Title from 'common/components/Title'
import { Button } from 'react-bootstrap'
import API from 'common/logic/API'
import OperationWorkflowModal from 'common/components/OperationWorkflowModal'
import EditUserWorkflow from './EditUserWorkflow'
import * as Icon from 'react-bootstrap-icons'
import { User } from 'types'

function UsersAdmin() {
    const [modal, setModal] = useState<{ type: string; id?: number; name?: string } | null>(null)
    const [refreshKey, setRefreshKey] = useState(0)
    const { results, error } = usePaginatedFetch<User>('/users', undefined, refreshKey)

    function refreshData() { setRefreshKey(k => k + 1) }
    function hideDialogs() { setModal(null) }

    const columnDefinitions = [
        new ColumnDefinition<User>('Username', 'username'),
        new ColumnDefinition<User>('Admin', obj => obj.isAdmin ? 'YES' : 'NO', 'td-size-s'),
        new ColumnDefinition<User>('Actions', obj => <>
            <Button variant="link" title="Edit" onClick={() => setModal({ type: 'edit', id: obj.id, name: obj.username })}>
                <Icon.Pencil />
            </Button> |
            <Button variant="link" title="Delete" onClick={() => setModal({ type: 'delete', id: obj.id, name: obj.username })}>
                <Icon.Trash />
            </Button>
        </>)
    ]

    let modalEl: React.ReactNode = null
    if (modal) {
        const completion = (result: unknown) => { hideDialogs(); if (result) refreshData() }
        switch (modal.type) {
            case 'delete':
                modalEl = <OperationWorkflowModal
                    confirmationStep={() => `Delete user "${modal.name}"?`}
                    executionStep={() => API.delete(`/users/${modal.id}`)}
                    completionCallback={completion}
                />
                break
            case 'create':
            case 'edit':
                modalEl = <EditUserWorkflow onSuccess={completion} entryId={modal.id} />
                break
            default:
        }
    }

    return (
        <>
            <Title title="Users" />
            {error && <p>Error!</p>}
            {results === null ? <BigSpinner /> : <>
                <Button variant="link" onClick={() => setModal({ type: 'create' })}>Add new</Button>
                <DataTable
                    columns={columnDefinitions as unknown as ColumnDefinition[]}
                    rows={results as unknown as Record<string, unknown>[]}
                />
            </>}
            {modalEl}
        </>
    )
}

export default UsersAdmin
